// INR formatting helper (Indian comma grouping, no decimals for whole rupees)
export const formatINR = (amount) => {
  const n = Number(amount) || 0;
  const hasPaise = Math.round(n * 100) % 100 !== 0;
  return `₹${n.toLocaleString('en-IN', {
    minimumFractionDigits: hasPaise ? 2 : 0,
    maximumFractionDigits: hasPaise ? 2 : 0,
  })}`;
};
